import axios from 'axios'

const atarrayaApiFaq = axios.create({
  baseURL: process.env.VUE_APP_ATARRAYA_API_URL,
  timeout: 100000
})

export const state = {
  faqs: []
}

export const getters = {
  faqs: (state) => state.faqs
}

export const mutations = {
  ADD_FAQ(state, data) {
    state.faqs.push(data)
  }
}

export const actions = {
  async addQuestion({ commit }, data) {
    const response = await atarrayaApiFaq.post('/chatbot', data)
    commit('ADD_FAQ', response.data.response)
    return response.data.response
  }
}
